import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchSetting'
})
export class SearchSettingPipe implements PipeTransform {

  transform(value: any, searchText: any): any {
    if(!searchText) {
      return value;
    }
    searchText = searchText.toLowerCase();
    return value.filter((data) => 
    {
   
      let check : boolean = false;
      if(data['key'].toLowerCase().startsWith(searchText))
      {
          check = true;
      }
      return check;
    }); 
  }

  matchValue(data, value) {
    return Object.keys(data).map((key) => {
       return new RegExp(value, 'gi').test(data[key]);
    }).some(result => result);
  }

}
